import React, {useState, useMemo} from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie'

import styles from './CurrencySelector.module.scss';

const cx = classnames.bind(styles);

const CurrencySelector = ({className, data}) => {
  const [isListShow, setIsListShow] = useState(false)
  const {
    cookieName,
    domain,
    currencies,
    selectTitle,
    currentCurrencyCode,
    currenCurrencyTitle,
  } = data;
  const currenciesToShow = useMemo(function () {
    return currencies
      ? Object.entries(currencies)
        .filter(([value]) => value !== currentCurrencyCode)
        .map(([value, label]) => ({label, value}))
      : null
  }, [currencies, currentCurrencyCode]);

  const selectCurrency = function (e, value) {
    e.preventDefault();
    e.stopPropagation();
    setIsListShow(false);

    // Update currency in cookies
    Cookies.remove(cookieName);
    Cookies.set(cookieName, value, {
      path: '/',
      domain,
    })

    window.location.reload()
  }

  return (
    <div className={cx('block-currency')}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div
        role="button"
        tabIndex="0"
        onClick={() => setIsListShow(true)}
        className={cx('block-currency__button', className)}
      >
        <span className={cx('block-currency__label', `block-currency__label--${currentCurrencyCode}`)}>
          <p className="sr-only">{currenCurrencyTitle}</p>
        </span>
      </div>
      {isListShow && currenciesToShow && (
        <div className={cx('block-currency__dropdown')}>
          {selectTitle && (<span className={cx('block-currency__dropdown-label')}>{selectTitle}</span>)}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
          <span role="button" tabIndex="0" onClick={() => setIsListShow(false)} className={cx('btn-close')}>X</span>
          <ul className={cx('block-currency__dropdown-list')}>
            { currenciesToShow.map(({label, value}) => (
              <li key={value} className={cx('block-currency__dropdown-item')}><a href={`#${value}`} onClick={(e) => selectCurrency(e, value)}>{label}</a></li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

CurrencySelector.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({

  }).isRequired
}

CurrencySelector.defaultProps = {
  className: '',
}

export default CurrencySelector;
